const hostname = window.location.hostname;

const isCloud = hostname === "cloud.wioss.no";
const isRema = hostname === "wimulerdo.rema.no";

export const WiMuleSQL = isRema
  ? import.meta.env.VITE_WIMULE_API_REMA
  : import.meta.env.VITE_WIMULE_API;

export const BMISAPI =
  isRema
    ? import.meta.env.VITE_BMIS_API_REMA
    : import.meta.env.VITE_BMIS_API;

export const WiGuardian =
  isRema
    ? import.meta.env.VITE_GUARDIAN_API_REMA
    : import.meta.env.VITE_GUARDIAN_API;
